"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "label-additional"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.getClasses())
    }, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.title), 1)
        ])), [
            [_directive_i18n]
        ]),
        (_ctx.withAdditional)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_1, (0, vue_1.toDisplayString)(_ctx.additional), 1))
            : (0, vue_1.createCommentVNode)("", true)
    ], 2));
}
